import { observer } from 'mobx-react';
import React from 'react';
import { useAnalytics } from '../../../app/data/AnalyticsProvider';
import { useStore } from '../../../app/data/root.store';
import { ReactComponent as BackArrowIcon } from '../../../onboarding/assets/back-arrow-icon.svg';
import { ReactComponent as LargeGroupSvg } from '../../../onboarding/components/Questionnaire/assets/large-group.svg';
import { ReactComponent as MediumGroupSvg } from '../../../onboarding/components/Questionnaire/assets/medium-group.svg';
import { ReactComponent as SingleFamilySvg } from '../../../onboarding/components/Questionnaire/assets/single-family.svg';
import { ReactComponent as SmallGroupSvg } from '../../../onboarding/components/Questionnaire/assets/small-group.svg';
import { ClientCountAnswerItemWrapper, GridAnswersWrapper, QuestionnaireBackButtonWrapper, QuestionnaireContentWrapper, QuestionnaireTitleWrapper, QuestionnaireTopSubTitle } from '../../../onboarding/components/Questionnaire/OnBoardingQuestionnaire.styles';
import { AdamImageComponent } from '../../../user-activation-flow/components/steps/MeetAdamStep';
import { AUTH_STEPS } from '../../../user/data/user.store';
import { StyledSignUpStepWrapper } from '../LoginPage.styles';

export const ClientCountStep = observer(() => {
  const { userStore } = useStore();
  const { trackEvent } = useAnalytics();

  const stepData = {
    title: 'How many clients do you manage?',
    answerOptions: [
      { label: 'Single family', icon: <SingleFamilySvg />, value: 'single' },
      { label: '2-10 families', icon: <SmallGroupSvg />, value: '2-10' },
      { label: '11-50 families', icon: <MediumGroupSvg />, value: '11-50' },
      { label: 'over 51 families', icon: <LargeGroupSvg />, value: '51+' }
    ]
  };

  const handleOptionSelect = (value) => {
    trackEvent('Questionnaire Step Completed', {
      step_name: 'client_count',
      step_selections: value
    });
    userStore.setAuthFields('clientCount', value);
    userStore.setAuthStep(AUTH_STEPS.SIGN_UP_STEP);
  };

  const handleBackClick = () => {
    userStore.setAuthStep(AUTH_STEPS.WEALTH_MANAGEMENT_TYPE_STEP);
  };

  return (
    <StyledSignUpStepWrapper>
      <QuestionnaireBackButtonWrapper onClick={handleBackClick} style={{ alignSelf: 'flex-start', paddingLeft: '4px' }}>
        <BackArrowIcon />Back
      </QuestionnaireBackButtonWrapper>
      
      <QuestionnaireTitleWrapper style={{marginTop: '106px'}}>
        <AdamImageComponent size={48} />
        <QuestionnaireTopSubTitle>{stepData.title}</QuestionnaireTopSubTitle>
      </QuestionnaireTitleWrapper>
      <QuestionnaireContentWrapper>
        <GridAnswersWrapper>
          {stepData.answerOptions.map((option, index) => (
            <ClientCountAnswerItemWrapper 
              key={index}
              index={index}
              onClick={() => handleOptionSelect(option.value)}
            >
              {option.icon}
              {option.label}
            </ClientCountAnswerItemWrapper>
          ))}
        </GridAnswersWrapper>
      </QuestionnaireContentWrapper>
    </StyledSignUpStepWrapper>
  );
}); 